import React, { useState } from "react";
import { Box, Button, TextField, Typography, Paper, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "../css/Login.module.css";

export default function Login({ onLoginSuccess }) {
  const [formData, setFormData] = useState({ Username: "", Contrasenia: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await fetch(`/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!res.ok) {
      const msg = await res.json().catch(() => ({}));
      throw new Error(msg.error || "Error de login");
    }

    const data = await res.json();
    console.log("Login exitoso", data);
    setError("");

    localStorage.setItem("user", JSON.stringify(data.user));
    if (onLoginSuccess) onLoginSuccess(data.user);
    navigate("/home", { replace: true });
  } catch (err) {
    setError(err.message);
  }
};

  return (
    <Paper elevation={3} className={styles.loginContainer}>
      <Typography variant="h5" gutterBottom align="center">
        Login
      </Typography>

      {error && <Alert severity="error" className={styles.errorAlert}>{error}</Alert>}

      <Box component="form" onSubmit={handleSubmit} className={styles.formContainer}>
        <TextField
          label="Usuario"
          name="Username"
          value={formData.Username}
          onChange={handleChange}
          required
          InputLabelProps={{ required: false }}
        />
        <TextField
          label="Contraseña"
          name="Contrasenia"
          type="password"
          value={formData.Contrasenia}
          onChange={handleChange}
          required
          InputLabelProps={{ required: false }}
        />
        <Button type="submit" variant="contained" color="primary">
          Iniciar Sesión
        </Button>
      </Box>

      <Box className={styles.footerContainer}>
        <img
          src="images/catieLogo.png"
          alt="Footer Logo 1"
          className={styles.footerLogo}
        />
        <img
          src="images/sesanLogo.png"
          alt="Footer Logo 2"
          className={styles.footerLogo}
        />
      </Box>
    </Paper>
  );
}
